// extracted by mini-css-extract-plugin
export default {"root":"UserAvatar_root__eYW7V","inbound":"UserAvatar_inbound__qdNju"};